document.addEventListener('DOMContentLoaded', () => {
  // JavaScript logic

  const fullPricePerBox = Number(window.fullPriceBox) || 44.99;
  let leastExpensiveBox = fullPricePerBox;
  let currentSelectedProduct = window.defaultSelectedProduct || null;
  let selectedShipFrequency = window.defaultShipFrequency || null;

  const primaryAddToCartBtn = document.querySelector(
    '#primary-add-to-cart'
  );

  const mobileAddToCartBtn = document.querySelector(
    '#mobile-add-to-cart'
  );

  const primaryAddToCartGiftBtn = document.querySelector(
    '#primary-add-to-cart-gift'
  );

  const mobileAddToCartGiftBtn = document.querySelector(
    '#mobile-add-to-cart-gift'
  );

  const productDropdownBtn = document.querySelector(
    '.custom-dropdown-btn.product'
  );

  const productDropdownMenu = document.querySelector(
    '.custom-dropdown-menu.product'
  );

  const shipDropdownBtn = document.querySelector(
    '.custom-dropdown-btn.ship'
  );

  const shipDropdownMenu = document.querySelector(
    '.custom-dropdown-menu.ship'
  );

  const dropdownMenuItems = document.querySelectorAll(
    '.custom-dropdown-menu.product li'
  );

  const dropdownShipItems = document.querySelectorAll(
    '.custom-dropdown-menu.ship li'
  );

  const showTotalInButton = !!window.gmcShowTotalInButton;
  const primaryBaseHTML = primaryAddToCartBtn
    ? primaryAddToCartBtn.innerHTML
    : '';
  const mobileBaseHTML = mobileAddToCartBtn
    ? mobileAddToCartBtn.innerHTML
    : '';
  const primaryGiftBaseHTML = primaryAddToCartGiftBtn
    ? primaryAddToCartGiftBtn.innerHTML
    : '';
  const mobileGiftBaseHTML = mobileAddToCartGiftBtn
    ? mobileAddToCartGiftBtn.innerHTML
    : '';

  function computeTotal(target) {
    if (!target || !target.dataset) return null;
    const priceStr = target.dataset.productPrice || '';
    const num = parseFloat(priceStr.replace(/[^0-9.]/g, ''));
    const pct = Number(window.gmcTotalDiscountPercent) || 0;
    if (isNaN(num) || pct <= 0) return priceStr || null;
    const sym = (priceStr.match(/^[^0-9]*/) || [''])[0];
    const discounted = num * (1 - pct / 100);
    return (
      sym +
      discounted.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    );
  }

  function setTotalLabel(target) {
    if (!showTotalInButton) return;
    const total = computeTotal(target);
    [
      [primaryAddToCartBtn, primaryBaseHTML],
      [mobileAddToCartBtn, mobileBaseHTML],
      [primaryAddToCartGiftBtn, primaryGiftBaseHTML],
      [mobileAddToCartGiftBtn, mobileGiftBaseHTML],
    ].forEach(function (pair) {
      const btn = pair[0];
      const base = pair[1];
      if (!btn) return;
      if (total) {
        let html = base.replace(/(\s*)(<img)/i, function (m, ws, img) {
          return ' - ' + total + ws + img;
        });
        if (html === base) {
          html = base + ' - ' + total;
        }
        btn.innerHTML = html;
      } else {
        btn.innerHTML = base;
      }
    });
  }

  function enableButtons() {
    primaryAddToCartBtn?.classList.remove('disabled');
    mobileAddToCartBtn?.classList.remove('disabled');

    primaryAddToCartGiftBtn?.classList.remove('disabled');
    mobileAddToCartGiftBtn?.classList.remove('disabled');
  }

  function disableButtons() {
    primaryAddToCartBtn?.classList.add('disabled');
    mobileAddToCartBtn?.classList.add('disabled');

    primaryAddToCartGiftBtn?.classList.add('disabled');
    mobileAddToCartGiftBtn?.classList.add('disabled');
  }

  function findMatchingProduct(numReceived, shipFrequency) {
    return Array.from(dropdownMenuItems).find(
      item =>
        Number(item.dataset.numReceived) === Number(numReceived) &&
        Number(item.dataset.shipFrequencyProduct) ===
          Number(shipFrequency)
    );
  }

  function selectShipFrequency(target, isInitialLoad = false) {
    if (!target) return;

    if (shipDropdownBtn) {
      shipDropdownBtn.innerHTML = target.innerHTML;
    }

    if (target.matches('[data-ship-frequency]')) {
      document
        .querySelectorAll('[data-ship-frequency]')
        .forEach(function (b) {
          b.classList.remove('btn-selected');
        });
      target.classList.add('btn-selected');
    }

    selectedShipFrequency =
      target.dataset.value || target.dataset.shipFrequency;

    if (shipDropdownMenu) {
      shipDropdownMenu.classList.remove('show');
    }

    updateVisibleItems(isInitialLoad);
  }

  function selectProduct(target, isInitialLoad = false) {
    if (isInitialLoad && currentSelectedProduct) {
      productDropdownBtn.innerHTML =
        currentSelectedProduct.label;

      if (target && target.dataset) {
        setTotalLabel(target);
      }

      return;
    }

    if (!target && !isInitialLoad) {
      currentSelectedProduct = null;

      productDropdownBtn.innerHTML = 'Select a plan';

      setTotalLabel(null);

      disableButtons();

      return;
    }

    const productId = target.dataset.value;
    const sellingPlanId = target.dataset.sellingPlan;
    const numReceived = target.dataset.numReceived;
    const shipFrequency =
      target.dataset.shipFrequencyProduct;

    productDropdownBtn.innerHTML = target.innerHTML;

    productDropdownMenu.classList.remove('show');

    currentSelectedProduct = {
      label: target.innerHTML,
      productId,
      sellingPlanId,
      numReceived,
      shipFrequency,
    };

    enableButtons();

    setTotalLabel(target);
  }

  function updateVisibleItems(isInitialLoad = false) {
    const currentShipFrequency = selectedShipFrequency;

    dropdownMenuItems.forEach(item => {
      if (
        Number(item.dataset.shipFrequencyProduct) ===
        Number(currentShipFrequency)
      ) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });

    if (currentSelectedProduct) {
      const currentNumReceived =
        currentSelectedProduct.numReceived;

      const matchingItem = findMatchingProduct(
        currentNumReceived,
        currentShipFrequency
      );

      selectProduct(matchingItem || null, isInitialLoad);
    }
  }

  /*
    =========================================================
    DROPDOWN CLICK HANDLERS
    =========================================================
  */

  productDropdownBtn?.addEventListener('click', e => {
    e.preventDefault();

    productDropdownMenu.classList.toggle('show');
  });

  shipDropdownBtn?.addEventListener('click', e => {
    e.preventDefault();

    shipDropdownMenu.classList.toggle('show');
  });

  dropdownMenuItems.forEach(item => {
    item.addEventListener('click', e => {
      const liElement = e.target.closest('li');

      selectProduct(liElement);
    });
  });

  dropdownShipItems.forEach(item => {
    item.addEventListener('click', e => {
      const liElement = e.target.closest('li');

      selectShipFrequency(liElement);
    });
  });

  // frequency TOGGLE buttons (rendered instead of the ship dropdown)
  document
    .querySelectorAll('[data-ship-frequency]')
    .forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        selectShipFrequency(btn);
      });
    });

  /*
    =========================================================
    REBUY SMART CART HELPERS
    =========================================================
  */

  async function refreshCartAndOpenDrawer() {
    try {
      const cart = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      }).then(res => res.json());

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          detail: { cart },
        })
      );

      window.dispatchEvent(
        new CustomEvent('cart:refresh', {
          detail: { cart },
        })
      );

      let attempts = 0;
      const maxAttempts = 25;

      const rebuyInterval = setInterval(() => {
        attempts++;

        if (window.Rebuy && window.Rebuy.SmartCart) {
          try {
            /*
              Sync latest Shopify cart into Rebuy
            */
            if (
              typeof window.Rebuy.SmartCart.setCart ===
              'function'
            ) {
              window.Rebuy.SmartCart.setCart(cart);
            }

            /*
              Open Rebuy Smart Cart flyout
            */
            if (
              typeof window.Rebuy.SmartCart.show ===
              'function'
            ) {
              window.Rebuy.SmartCart.show();
            }

            clearInterval(rebuyInterval);
          } catch (rebuyError) {
            console.error(
              'Rebuy Smart Cart error:',
              rebuyError
            );
          }
        }

        /*
          =========================================================
          UPDATED FALLBACK BEHAVIOR
          =========================================================

          OLD CODE:
          window.location.href = '/cart';

          Problem:
          This caused the customer to:
          Product page -> Cart page -> Homepage -> Rebuy Flyout

          NEW BEHAVIOR:
          Stay on the page if Rebuy fails to initialize.
        */

        if (attempts >= maxAttempts) {
          clearInterval(rebuyInterval);

          console.warn(
            'Rebuy Smart Cart did not initialize. Staying on page instead of redirecting to /cart.'
          );
        }
      }, 200);
    } catch (error) {
      console.error('Cart refresh failed:', error);

      /*
        =========================================================
        UPDATED ERROR FALLBACK
        =========================================================

        OLD CODE:
        window.location.href = '/cart';

        NEW BEHAVIOR:
        Stay on page instead of redirecting.
      */

      console.warn(
        'Cart refresh failed. Staying on page instead of redirecting to /cart.'
      );
    }
  }

  /*
    =========================================================
    ADD TO CART BUTTONS
    =========================================================
  */

  primaryAddToCartBtn?.addEventListener(
    'click',
    async function (e) {
      e.preventDefault();

      if (!currentSelectedProduct) return;

      await prepaidAddToCart(
        currentSelectedProduct.productId,
        currentSelectedProduct.sellingPlanId
      );
    }
  );

  mobileAddToCartBtn?.addEventListener(
    'click',
    async function (e) {
      e.preventDefault();

      if (!currentSelectedProduct) return;

      await prepaidAddToCart(
        currentSelectedProduct.productId,
        currentSelectedProduct.sellingPlanId
      );
    }
  );

  primaryAddToCartGiftBtn?.addEventListener(
    'click',
    async function (e) {
      e.preventDefault();

      if (!currentSelectedProduct) return;

      const giftModal = document.querySelector('[id^="gift_modal_"]');
      const giftForm = document.querySelector('[id^="gn-form-"]');

      if (giftForm) {
        giftForm.dataset.productId = currentSelectedProduct.productId;
        giftForm.dataset.sellingPlan = currentSelectedProduct.sellingPlanId;
      }

      giftModal?.show(e.target);
    

      /*
        OLD CODE:
        await prepaidAddToCart(selectedProduct, selectedSellingPlan, true);
      */
    }
  );

  mobileAddToCartGiftBtn?.addEventListener(
    'click',
    async function (e) {
      e.preventDefault();

      if (!currentSelectedProduct) return;

      const giftModal = document.querySelector('[id^="gift_modal_"]');
      const giftForm = document.querySelector('[id^="gn-form-"]');

      if (giftForm) {
        giftForm.dataset.productId = currentSelectedProduct.productId;
        giftForm.dataset.sellingPlan = currentSelectedProduct.sellingPlanId;
      }

      giftModal?.show(e.target);
    }
  );

  /*
    =========================================================
    AJAX ADD TO CART
    =========================================================
  */

  async function prepaidAddToCart(
    productId,
    sellingPlan = null,
    isGift = false
  ) {
    const body = {
      id: productId,
      quantity: 1,
      properties: {
        _is_subscription: true,
      },
    };

    if (isGift) {
      body.properties = {
        ...body.properties,
        _is_gift: true,
      };
    }

    if (!!sellingPlan) {
      body.selling_plan = sellingPlan;
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    await response.json();

    /*
      =========================================================
      NEW REBUY FIX
      =========================================================

      OLD BEHAVIOR:
      Product was added to cart, but Rebuy Smart Cart
      was not refreshed/opened here.

      NEW BEHAVIOR:
      Refresh Shopify cart, sync it with Rebuy Smart Cart,
      and open the flyout immediately.
    */

    await refreshCartAndOpenDrawer();
  }

  /*
    =========================================================
    INITIALIZE DEFAULTS
    =========================================================
  */

  let defaultShipFrequencyEl =
    shipDropdownMenu?.querySelector(
      `li[data-value="${selectedShipFrequency}"]`
    );

  if (!defaultShipFrequencyEl) {
    defaultShipFrequencyEl =
      shipDropdownMenu?.querySelector('li[data-value]');
  }

  if (!defaultShipFrequencyEl) {
    defaultShipFrequencyEl =
      document.querySelector(
        '[data-ship-frequency][data-default-frequency="true"]'
      ) || document.querySelector('[data-ship-frequency]');
  }

  if (defaultShipFrequencyEl) {
    selectShipFrequency(defaultShipFrequencyEl, true);
  }

  if (currentSelectedProduct) {
    enableButtons();
  }
});